import { useSyncExternalStore } from 'react';
import { getAccountView, getSession, isSignInOpen, subscribeSession, subscribeSignIn } from '../lib/auth';

export function useSession() {
  return useSyncExternalStore(subscribeSession, getSession, getSession);
}

export function useSignInOpen() {
  return useSyncExternalStore(subscribeSignIn, isSignInOpen, isSignInOpen);
}

export function useAccountView() {
  return useSyncExternalStore(subscribeSignIn, getAccountView, getAccountView);
}
